import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics.js';

/**
 * Medición GA4 en rutas públicas. La etiqueta base está en public/index.html.
 * Excluye /admin y evita duplicar la vista de la primera carga (ya la envía index.html).
 */
export default function GoogleAnalytics() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');
  const skipInitialRef = useRef(true);

  useEffect(() => {
    if (isAdmin) return;

    const path = location.pathname + location.search;
    if (skipInitialRef.current) {
      skipInitialRef.current = false;
      return;
    }

    trackPageView(path);
  }, [location.pathname, location.search, isAdmin]);

  return null;
}
